jQuery(document).ready(function (e) {
  e(".single-item").slick({
    asNavFor: ".captions",
    centerMode: !0,
    centerPadding: "10%",
    lazyLoad: "ondemand",
    responsive: [
      { breakpoint: 768, settings: { centerMode: !1, centerPadding: "0" } },
    ],
  }),
    e(".captions").slick({
      asNavFor: ".single-item",
      fade: !0,
      arrows: !1,
      prevArrow: "",
      nextArrow: "",
    }),
    e(".single-item-full").slick({
      asNavFor: ".captions-full",
      slidesToShow: 1,
      slidesToScroll: 1,
      lazyLoad: "ondemand",
      responsive: [
        { breakpoint: 768, settings: { centerMode: !1, centerPadding: "0" } },
      ],
    }),
    e(".captions-full").slick({
      asNavFor: ".single-item-full",
      fade: !0,
      arrows: !1,
      prevArrow: "",
      nextArrow: "",
    });
}),
  jQuery(document).ready(function (s) {
    s("#instagram .images").slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      lazyLoad: "ondemand",
      prevArrow:
        "<button type='button' class='slick-prev pull-left'><</button>",
      nextArrow:
        "<button type='button' class='slick-next pull-right'>></button>",
      responsive: [
        { breakpoint: 1424, settings: { slidesToShow: 4 } },
        { breakpoint: 1024, settings: { slidesToShow: 3 } },
        { breakpoint: 600, settings: { slidesToShow: 2 } },
        { breakpoint: 480, settings: { slidesToShow: 1 } },
      ],
    }),
      s(".slick-arrow").text("");
  });

jQuery(document).ready(function ($) {
  $(".sidebar-images").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: 0,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: "unslick",
      },
    ],
  });

  jQuery(".navbar-toggler").on("click", function () {
    if (jQuery(this).attr("aria-expanded") == "false") {
      jQuery(".site-branding-text svg path").css("fill", "black");
      // jQuery('.site-branding-text svg path').css('z-index', '95');
    } else {
      jQuery(".site-branding-text svg path").css("fill", "white");
    }
  });
});

// flyovers
jQuery(".flyover-tile").on("click", function () {
  jQuery(".flyover-tile").removeClass("active");
  jQuery(this).addClass("active");
});
jQuery("#flyovers .modal").on("shown.bs.modal", function () {
  var modalSrc = jQuery(".flyover-tile.active").attr("data-modal-src");
  var dataType = jQuery(".flyover-tile.active").attr("data-type");
  var video = jQuery(this).find("video");
  var iframe = jQuery(this).find("iframe");
  if (dataType === "video") {
    jQuery("#flyovers .responsive-video").hide();
    video.attr("src", modalSrc + "?autoplay=1");
    video.show();
  } else {
    video.hide();
    iframe.attr("src", modalSrc);
    jQuery("#flyovers .responsive-video").show();
  }
});
